import {
  COOKIE_MANAGEMENT_TYPES,
  COOKIES_KEYS,
  getLocalStorageValue,
  LOCAL_STORAGE_KEYS,
  setCookie
} from '@namespace/helpers';
import { setAccountingLanguage } from '../api';

export const setHtmlLang = (lang) => {
  // set language to html for correct displaying some upper-case words in application

  // https://developer.mozilla.org/en-US/docs/Web/CSS/text-transform

  // In Turkic languages, like Turkish (tr), Azerbaijani (az), Crimean Tatar (crh),
  // Volga Tatar (tt), and Bashkir (ba),
  // there are two kinds of i, with and without the dot, and two case pairings: i/İ and ı/I.
  // should be set before application render
  document.documentElement.lang = lang;
};

const setCookieLang = (lang, cookieManagementEnabled) => {
  const cookieManagementType = getLocalStorageValue(
    LOCAL_STORAGE_KEYS.COOKIE_MANAGEMENT_TYPE,
    ''
  );

  const IS_FUNCTIONAL = cookieManagementType?.includes(
    COOKIE_MANAGEMENT_TYPES.FUNCTIONAL
  );

  if (!cookieManagementEnabled || IS_FUNCTIONAL) {
    setCookie(COOKIES_KEYS.LANGUAGE, lang, { expires: 365 });
  }
};

export const setLang = (lang, cookieManagementEnabled) => {
  setCookieLang(lang, cookieManagementEnabled);
  setHtmlLang(lang);
  setAccountingLanguage(lang);
};
